import Spinner from 'common/components/spinner'
import Filters from 'features/personalization/components/report/Filters'

import useGetGraphsQuery from '../api/queries/useGetGraphs'
import useGetHeadersQuery from '../api/queries/useGetHeaders'
import useGetSelectedFiltersQuery from '../api/queries/useGetSelectedFilters'
import Page from '../components/Page'

import Graphs from './components/graphs/Graphs'
import Header from './Header'

const ExperimentReport = () => {
  const headersQuery = useGetHeadersQuery()
  const selectedFiltersQuery = useGetSelectedFiltersQuery()
  const graphsQuery = useGetGraphsQuery()

  const getState = () => {
    if (
      headersQuery.isLoading ||
      selectedFiltersQuery.isLoading ||
      graphsQuery.isLoading
    ) {
      return 'loading'
    } else {
      return 'success'
    }
  }
  const state = getState()

  return (
    <>
      {
        {
          success: (
            <>
              <Header />

              <Page>
                <div className="flex flex-col flex-1 w-full bg-coolGray-50">
                  <Filters />
                  <Graphs />
                </div>
              </Page>
            </>
          ),
          loading: (
            <div className="w-full">
              <Spinner data-testid="contents-loader" />
            </div>
          ),
        }[state]
      }
    </>
  )
}

export default ExperimentReport
